import { CaseGranulometry } from '../../CaseGranulometry';
import { CaseId } from '../../../../specification/cases/CaseSpecification';

export const hasCaseId = (caseId: CaseId) => (caseGranulometry: CaseGranulometry) =>
  caseGranulometry.id === caseId;
